// MOCK – stato del CV del profilo finché il backend non lo espone (SmartCV, candidatura da radar).
// Decide la variante dello step "Inoltra il CV" (SMARTCV_CANDIDATURA_PROCESSI.md):
// - 'none': nessun CV nel profilo (caso A, "Iniziamo dal tuo CV"); dopo "Carica CV" riga del file e "Prosegui" (caso A1)
// - 'unconfirmed': CV presente, dati del parsing non confermati (caso C, riga del file e "Prosegui")
// - 'confirmed' con `file`: profilo confermato, scelta tra il file e "Profilo CVing" (caso B)
// - 'confirmed' con `file: null`: CV eliminato da "Il mio CV", "Carica un tuo CV" / "Prosegui con profilo CVing" (caso B3)
// Per provare un caso si cambiano `status` e `file` qui sotto. `file` è il PDF del profilo (ignorato nel caso A).
export default {
  status: 'none',
  file: {
    name: 'Roberto russo CV.pdf',
    url: ''
  }
}
